// @flow

import ReactDOM from 'react-dom';
import { Component, type Node } from 'react';

const isNodeInViewport = (node: Element) => {
  // make flow happy
  if (!document.body) return false;

  const bodyHeight = document.body.offsetHeight;
  const bounds = node.getBoundingClientRect();

  return (
    bounds.top > 0 && (bounds.bottom < bodyHeight || bounds.height > bodyHeight)
  );
};

type Props = {
  children: Node,
  /** Should the scrollIntoView behavior be triggered even if the node is already in the viewport? */
  shouldForce?: boolean,
  shouldScrollIntoView?: boolean,
  behavior?: 'auto' | 'instant' | 'smooth',
};

class ScrollIntoViewIfNeeded extends Component<Props> {
  static defaultProps = {
    behavior: 'auto',
    shouldScrollIntoView: true,
  };

  componentDidMount() {
    if (this.props.shouldScrollIntoView) {
      this.scrollIntoViewIfNeeded();
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.shouldScrollIntoView && !prevProps.shouldScrollIntoView) {
      this.scrollIntoViewIfNeeded();
    }
  }

  scrollIntoViewIfNeeded() {
    const domNode = ReactDOM.findDOMNode(this);
    if (
      domNode &&
      domNode instanceof Element &&
      (!isNodeInViewport(domNode) || this.props.shouldForce) &&
      domNode.scrollIntoView
    ) {
      domNode.scrollIntoView({
        behavior: this.props.behavior,
      });
    }
  }

  render() {
    return this.props.children;
  }
}

export default ScrollIntoViewIfNeeded;
